import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { Link } from '@digdir/designsystemet-react';

const HiddenLinkWrapper = styled.div`
  width: 100%;
  background: var(--ds-color-base-default);
  display: flex;
  justify-content: center;
  align-items: center;
  transform: translateY(-120%);
  height: 0;
  overflow: hidden;

  a {
    color: var(--ds-color-base-contrast-default);
    font-size: var(--ds-size-5);
  }

  &:focus-within {
    transform: translateY(calc(0%));
    height: var(--ds-size-18);
  }
`;

export const SkipToContentLink = () => {
  const { t } = useTranslation();

  return (
    <HiddenLinkWrapper>
      <Link href="#main">{t('skipToContent')}</Link>
    </HiddenLinkWrapper>
  );
};
